import React, { useEffect, useState } from "react";

import NoData from "../../components/Nodata";

import api from "../../services/api";
import useStore from "../../store";

const Dashboard = () => {
  const [users, setUsers] = useState(0);
  const [customers, setCustomers] = useState(0);
  const [visits, setVisits] = useState(0);
  const [study, setStudy] = useState(0);
  const [other, setOther] = useState(0);
  const [revenue, setRevenue] = useState(0);
  const [received, setReceived] = useState(0);
  const [incentives, setIncentives] = useState(0);

  const { user } = useStore();

  useEffect(() => {
    getData();
  }, []);

  const getData = async (e) => {
    try {
      const filters = {};

      if (user.role !== "admin") filters.assignee = user.username;
      if (user.role !== "admin") filters.created_by = user.username;
      if (user.role !== "admin") filters.user_id = user.id;

      const { data: cstmrs } = await api.post("customer/stats", filters);
      setCustomers(cstmrs.total);
      setVisits(cstmrs.total_visit);
      setStudy(cstmrs.total_study);
      setOther(cstmrs.total_other);

      const { data: allC } = await api.post("customer/search", filters);

      const rvn = (allC.customers || []).reduce(
        (acc, c) =>
          acc +
          (c.services || []).reduce((sacc, s) => sacc + parseInt(s.fee), 0),
        0
      );

      setRevenue(rvn);

      const { data: allP } = await api.post("payment/search", filters);

      const rcvd = (allP.payments || []).reduce((acc, c) => acc + c.amount, 0);

      setReceived(rcvd);

      const { data: allI } = await api.post("incentive/search", filters);

      const incnt = (allI.incentives || []).reduce(
        (acc, c) => acc + c.amount,
        0
      );

      setIncentives(incnt);

      const { data: users } = await api.post("user/stats", filters);
      setUsers(users.total);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="p-5">
      {/* Dashboard Title */}
      <h1 className="text-3xl font-bold mb-6">Dashboard</h1>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
        <div class="bg-white p-4 rounded-2xl shadow-md">
          <h2 class="text-sm font-semibold text-gray-700">Total Customers</h2>
          <div class="mt-1 text-3xl font-bold">{customers}</div>
          <div class="mt-5 text-sm text-gray-500">
            Visit Visa: <span className="font-semibold">{visits}</span> | Study
            Visa: <span className="font-semibold">{study}</span> | Other:{" "}
            <span className="font-semibold">{other}</span>
          </div>
        </div>

        <div class="bg-white p-4 rounded-2xl shadow-md">
          <h2 class="text-sm font-semibold text-gray-700">My incentives</h2>
          <div class="mt-1 text-3xl font-bold">
            {incentives} <span className="text-gray-300">PKR</span>
          </div>
          <div class="mt-5 text-sm text-gray-500">
            Last Incentive:{" "}
            <span className="font-semibold">
              {formatAmount(incentives)}{" "}
              <span className="text-gray-300">PKR</span>
            </span>
          </div>
        </div>
      </div>
      {/* Tables Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <RecentCustomers />
        <RecentPayments />
      </div>
    </div>
  );
};

export default Dashboard;

const RecentCustomers = () => {
  const [customers, setCustomers] = useState([]);

  const { user } = useStore();

  useEffect(() => {
    getData();
  }, []);

  const getData = async (e) => {
    try {
      const filters = {
        sortBy: "created_at",
        limit: 10,
      };
      if (user.role !== "admin") filters.assignee = user.username;
      const { data } = await api.post("customer/search", filters);
      setCustomers(data.customers);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="bg-white shadow-md rounded-lg p-6">
      <h3 className="text-lg font-bold text-gray-800 mb-4">Recent customers</h3>
      <table className="w-full text-left border-collapse">
        <thead>
          <tr>
            <th className="border-b py-2 text-sm text-gray-600">Customer</th>
            <th className="border-b py-2 text-sm text-gray-600">Category</th>
            <th className="border-b py-2 text-sm text-gray-600">Date</th>
          </tr>
        </thead>
        <tbody>
          {customers.map((payment) => (
            <tr key={payment.id}>
              <td className="border-b text-sm py-2 px-2">{payment.name}</td>
              <td className="border-b text-sm py-2 px-2">{payment.category}</td>
              <td className="border-b text-sm py-2 px-2">
                {new Date(payment.created_at).toLocaleDateString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {!customers.length && <NoData />}
    </div>
  );
};

const RecentPayments = () => {
  const [payments, setPayments] = useState([]);

  const { user } = useStore();

  useEffect(() => {
    getData();
  }, []);

  const getData = async (e) => {
    try {
      const filters = {
        limit: 10,
      };
      if (user.role !== "admin") filters.created_by = user.username;
      const { data } = await api.post("payment/search", filters);
      setPayments(data.payments);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="bg-white shadow-md rounded-lg p-6">
      <h3 className="text-lg font-bold text-gray-800 mb-4">Recent payments</h3>
      <table className="w-full text-left border-collapse">
        <thead>
          <tr>
            <th className="border-b py-2 text-sm text-gray-600">Customer</th>
            <th className="border-b py-2 text-sm text-gray-600">Amount</th>
            <th className="border-b py-2 text-sm text-gray-600">Date</th>
            <th className="border-b py-2 text-sm text-gray-600">Remaining</th>
          </tr>
        </thead>
        <tbody>
          {payments.map((payment) => (
            <tr key={payment.id}>
              <td className="border-b text-sm py-2 px-2">
                {payment.customer_name}
              </td>
              <td className="border-b text-sm py-2 px-2">{payment.amount}</td>
              <td className="border-b text-sm py-2 px-2">
                {new Date(payment.created_at).toLocaleDateString()}
              </td>
              <td className="border-b text-sm py-2 px-2">
                {payment.remaining || "todo"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {!payments.length && <NoData />}
    </div>
  );
};

function formatAmount(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
